











































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import SettingsLocationForm from "./SettingsLocationForm.vue";

import ModulesJson from "../../shared/ModulesJson";
import LocationJson, {
  defaultLocationJson,
  validateLocationJson,
  validateLocationJsonAddNew,
} from "../../shared/LocationJson";

import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";

import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsLocationDetails",
  components: {
    OverlayWindow,
    Loading,
    SettingsLocationForm,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    locationId: Number,
  },
  data() {
    return {
      editable: false as boolean,
      detailsTitle: "",
      detailsMode: "",
      selectedId: null as number | null,
      details: null as LocationJson | null,
      allLocations: null as LocationJson[] | null,
      loading: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.selectDetailsMode(this.mode);
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Ort hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Ort bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Ort";
          this.editable = false;
          break;
      }
    },
  },
  watch: {},
  computed: {},
});
